<template>
  <div class="wc-row">
    <div class="wc-col wc-col__sm-6 wc-col__md-8">
      <IdLevelBox></IdLevelBox>
      <QuoteList
        v-if="partnerProxyId && showQuotes()"
        :partner-proxy-id="partnerProxyId"
      ></QuoteList>
      <PolicyList v-if="partnerProxyId" :partner-proxy-id="partnerProxyId"></PolicyList>
    </div>
    <div class="wc-col wc-col__sm-6 wc-col__md-4">
      <TeaserListPolicies></TeaserListPolicies>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import TeaserListPolicies from '@/componentsTenant/rahmen/TeaserListPolicies.vue'
import { getPartnerProxyId } from '@/utils/KeycloakUtils'
import PolicyList from '@/components/policy/PolicyList.vue'
import QuoteList from '@/components/quote/QuoteList.vue'
import IdLevelBox from '@/components/account-management/idlevelupgrade/IdLevelBox.vue'

const partnerProxyId = ref<string | null>(null)

onBeforeMount(() => {
  partnerProxyId.value = getPartnerProxyId()
})

const isTrue = (value: string | boolean) =>
  !!value && value.toString().toLowerCase() === 'true'

const showQuotes = () => isTrue(globalThis.ENV_CONFIG?.FEATURE_FLAGS.SHOW_QUOTES)
</script>
